var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 17,
    viewBox: "0 0 9 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 0C5.97012 0 3.90349 0.856024 2.37976 2.37976C0.856025 3.90349 1.62689e-07 5.97012 0 8.125C-1.62689e-07 10.2799 0.856024 12.3465 2.37976 13.8702C3.90349 15.394 5.97011 16.25 8.125 16.25L8.125 8.125V0Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrent);
export default __webpack_public_path__ + "static/media/current.6e2714643da1677efc77ccd3a727e2a4.svg";
export { ForwardRef as ReactComponent };